import ClientOverviewPage from 'components/Client/OverviewPage/OverviewPage'
import ClientPortfolioPage from 'components/Client/PortfolioPage/PortfolioPage'
import ClientDocumentsPage from 'components/Client/DocumentsPage/DocumentsPage'
import ClientUploaderPage from 'components/Client/UploaderPage/UploaderPage'
import ClientProfileSettingsPage from 'components/Client/ProfileSettingsPage/ProfileSettingsPage'

export default {
  CLIENT_OVERVIEW: ClientOverviewPage,
  CLIENT_PORTFOLIO: ClientPortfolioPage,
  CLIENT_DOCUMENTS: ClientDocumentsPage,
  CLIENT_UPLOADER: ClientUploaderPage,
  CLIENT_PROFILE_SETTINGS: ClientProfileSettingsPage,
  CLIENT_LOGIN: null
}



// WEBPACK FOOTER //
// ./src/routing/router/client.js